/**
 * Provides icons
 */

import React from 'react';
import { range } from 'lodash';
import styled from 'styled-components';
import { color, space, typography } from 'styled-system';

import { Container } from 'theme/layout';

export const Icon = styled('i')<App.Theme.NakedIcon.IconProps>`
  font-family: 'nakedicons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${typography};
  ${space};
  ${color};
`;

/**
 * Naked Icons from our own icon pack
 *
 * @param props - Icon render props
 */
export function NakedIcon(props: App.Theme.NakedIcon.Props) {
  const { size, name, color: iconColor, paths, customComponent, onClick } = props;
  let Component = Icon;

  if (customComponent) {
    Component = customComponent as typeof Icon;
  }

  return (
    <Component
      style={{ MozOsxFontSmoothing: 'unset', WebkitFontSmoothing: 'unset' }}
      className={`icon-${name}`}
      fontSize={`${size}px`}
      color={iconColor}
      onClick={onClick}
    >
      {paths &&
        range(paths).map((path: number) => (
          <Container as="span" key={path + 1} className={`path${path + 1}`} />
        ))}
    </Component>
  );
}
